import { useLocation /* other hooks */ } from "react-router-dom";

const withRouter = (Component) => (props) => {
  const location = useLocation();
  // other hooks
  return <Component {...props} {...{ location /* ...other hooks */ }} />;
};

export default withRouter;
